import CarouselWidget from './components/CarouselWidget';

export default function RegisterWidget(app) {
  // 注册到 forum-widgets-core 使用 app.widgets.add
  if (app.widgets && app.widgets.add) {
    try {
      // 在 admin 环境中，使用 app.data.settings 而不是 app.forum.attribute
      const itemCount = parseInt(app.data?.settings?.['custom-carousel-widget.item_count']) || 0;
      
      app.widgets.add({
        key: 'carouselWidget',
        component: CarouselWidget,
        isDisabled: false, // 暂时设为 false 来测试
        isUnique: true,
        placement: 'end',
        position: 1
      }, 'tf-carousel-widget');
    } catch (error) {
      console.warn('Could not register carousel widget:', error);
    }
  } else {
    console.warn('app.widgets not available');
  }
}
